module.exports = __webpack_public_path__ + "images/interview-PwC-2.svg";